import { render, staticRenderFns } from "./MainKind.vue?vue&type=template&id=6fda4f00&scoped=true&"
import script from "./MainKind.vue?vue&type=script&lang=js&"
export * from "./MainKind.vue?vue&type=script&lang=js&"
import style0 from "./MainKind.vue?vue&type=style&index=0&id=6fda4f00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fda4f00",
  null
  
)

export default component.exports